import React from "react";
import Title from "../../../../../utils/title/Title";
import { Colors } from "../../../../../utils/colors/colors";
import ButtonComponent from "../../../../../utils/button/ButtonComponent";
import { Link } from "react-scroll";
import { IHeaderType } from "../../../../../types/types";



export default function Left() {
  const { whiteColor, primaryColor } = Colors();



  return (
    <>
      <Title
        textColor={whiteColor}
        text={"Welcome to the Future of Business Success"}
        style={{
          margin: "0",
        }}
        type={IHeaderType.h1}
      />

      <div className="bottom-text">
        We reimagine business success through visionary solutions tailored to
        accelerate growth beyond imagination, pushing the boundaries of what's
        possible and delivering extraordinary outcomes.
      </div>

      <Link
        to={"contact-us"}
        activeClass="active"
        spy={true}
        smooth={true}
        offset={-70}
        duration={500}
      >
        <ButtonComponent
          data-aos="fade-up"
          data-aos-once="true"
          bgColor={whiteColor}
          text={"Get In Touch"}
          click={function (): void {
            console.log("Button clicked");
          }}
          isLoading={false}
          style={{
            color: primaryColor,
            
          }}
        />
      </Link>
    </>
  );
}
